/* eslint-disable import/no-unresolved */
import { bool, shape, string } from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import FormattedAmount from "pages/_components/FormattedAmount";
import FormattedDate from "pages/_components/FormattedDate";
import Heading from "pages/_components/Heading";
import I18n from "pages/_components/I18n";

import { selectors as sessionSelectors } from "reducers/session";

import * as i18nUtils from "util/i18n";

import Hint from "pages/_components/hints/Hint";
import { selectors as transactionsSelectors } from "reducers/transactions";
import * as config from "util/config";
import { getDebitAccountTicketLabel } from "util/accounts";

class ExternalTransactionSummaryData extends Component {
    static propTypes = {
        summary: shape({}).isRequired,
        fullName: string.isRequired,
        isDesktop: bool.isRequired,
        signature: bool,
        getAccountInfo: shape({}).isRequired,
    };

    static defaultProps = {
        signature: false,
    };

    preparedBy = () => {
        const { summary, fullName } = this.props;
        return (
            <p>
                {summary?.creatorFullName || fullName} -{" "}
                <FormattedDate date={summary?.creationDate || new Date()} dateFormat="dd/MM/yyyy" showTime />
            </p>
        );
    };

    signBy = () => {
        const { summary } = this.props;
        return (
            <p>
                {summary?.signatures.map((object) => (
                    <>
                        {object?.userFirstName.concat(" ", object?.userLastName)} -{" "}
                        <FormattedDate date={object?.creationDateTime} dateFormat="dd/MM/yyyy" showTime />
                        <br />
                    </>
                ))}
            </p>
        );
    };

    getAccountDescription = () => {
        const { getAccountInfo } = this.props;
        return getDebitAccountTicketLabel(getAccountInfo);
    };

    render() {
        const {
            summary: {
                signatures,
                idTransaction,
                debitAccount,
                creditAccount,
                amount,
                reference,
                currency,
                sendEmail,
                email,
                emailText,
                idActivityOriginal,
                beneficiaryDocumentNumber,
                beneficiaryName,
                bank,
            },
            getAccountInfo,
            isDesktop,
            signature,
        } = this.props;

        const amountValue = amount?.quantity || amount;
        const currencyValue = currency?.toString() || (amount?.currency ? amount.currency.toString() : "");
        const transferCvuEnabled = config.getBoolean("transfer.cvu.enabled");
        const isCVU = !!creditAccount?.startsWith("000");
        return (
            <>
                <>
                    <Heading.DataGroup
                        containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                        dataClassName="data-desc"
                        label="transferConfirmation.idTransaction.label"
                        data={<p className="data-desc m-0">{idTransaction?.substring(0, 8).toUpperCase()}</p>}
                    />
                </>

                <Heading.DataGroup
                    containerClassName={`transfer-data data-wrapper-flex ${isDesktop ? "mb-2" : "mb-3"} ${
                        isDesktop ? "" : "space-between"
                    }`}
                    label="transfers.debitAccount.label"
                    data={debitAccount && this.getAccountDescription()}
                />

                <Heading.DataGroup
                    containerClassName={`transfer-data data-wrapper-flex ${isDesktop ? "" : "space-between"}`}
                    label={
                        transferCvuEnabled
                            ? `transferSummary.${!isCVU ? "cbu" : "cvu"}.label`
                            : "transferSummary.cbu.label"
                    }
                    data={creditAccount && creditAccount.slice(-14, -1)}
                />

                {idActivityOriginal && (
                    <Heading.DataGroup
                        containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                        labelClassName="data-label-medium"
                        dataClassName="data-desc"
                        label="transactions.list.filters.transaction.activity.label"
                        data={<p className="data-desc m-0">{i18nUtils.get(`activity.${idActivityOriginal}`)}</p>}
                    />
                )}

                <Heading.DataGroup
                    containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                    labelClassName="data-label-medium"
                    dataClassName="data-desc"
                    label="transferSummary.cuit.label"
                    data={<p className="data-desc m-0">{beneficiaryDocumentNumber}</p>}
                />

                <Heading.DataGroup
                    containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                    labelClassName="data-label-medium"
                    dataClassName="data-desc"
                    label="transferSummary.owner.label"
                    data={<p className="data-desc m-0">{beneficiaryName}</p>}
                />

                <Heading.DataGroup
                    containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                    labelClassName="data-label-medium"
                    dataClassName="data-desc"
                    label={`transferSummary.${!isCVU ? "bank" : "entity"}.label`}
                    data={<p className="data-desc m-0">{bank}</p>}
                />
                {amount && (
                    <Heading.DataGroup
                        containerClassName={`transfer-data data-wrapper-flex ${isDesktop ? "" : "space-between"}`}
                        dataClassName="data-desc small-font"
                        label="transfers.amount.label"
                        data={
                            <FormattedAmount
                                currency={currencyValue}
                                quantity={amountValue}
                                notBold
                                className={`${isDesktop ? "f-size-4" : "f-size-65"}`}
                            />
                        }
                    />
                )}

                <Heading.DataGroup
                    containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                    labelClassName="data-label-medium"
                    dataClassName="data-desc"
                    label="transactions.list.item.date"
                    data={<p className="data-desc m-0">{i18nUtils.get("scheduler.executeToday")}</p>}
                />
                <Heading.DataGroup
                    containerClassName={`transfer-data data-wrapper-flex ${isDesktop ? "" : "space-between"}`}
                    label="transfers.reference.label"
                    data={reference}
                />

                {getAccountInfo && getAccountInfo.idProduct && getAccountInfo.productType !== "CA" && (
                    //  transferKind === "other" &&
                    // &&
                    <Hint
                        defaultValue={config.get(`transferencias.impuestos${getAccountInfo?.productType}.Texto`)}
                        styleText={{
                            maxWidth: "35rem",
                        }}
                        classNameGroup="transfer__text-hint"
                        classNameMessage="d-flex align-items-center"
                        styleDiv={{ marginLeft: "0.5rem" }}
                        styleImage={{ alignSelf: "center", margin: !isDesktop && "2rem 0 1.5rem" }}
                        classNameHintP="font-weight-normal my-0"
                        alwaysShowMessage
                    />
                )}
                {email && sendEmail && (
                    <Heading.DataGroup
                        containerClassName={`transfer-data data-wrapper-flex ${isDesktop ? "" : "space-between"}`}
                        label="transfers.email.label"
                        data={email}
                    />
                )}
                {email && emailText && sendEmail && (
                    <Heading.DataGroup
                        containerClassName={`transfer-data data-wrapper-flex ${isDesktop ? "" : "space-between"}`}
                        label="transfers.emailText.label"
                        data={emailText}
                    />
                )}

                {signature && (
                    <>
                        <I18n
                            component="h3"
                            id="accounts.new.account.signatures.label"
                            componentProps={{ className: "font-size-25-px" }}
                        />
                        <Heading.DataGroup
                            containerClassName={`transfer-data data-wrapper-flex ${isDesktop ? "" : "space-between"}`}
                            label="accounts.new.account.signatures.preparedBy.label"
                            data={this.preparedBy()}
                        />
                        {signatures?.length > 0 && (
                            <>
                                <Heading.DataGroup
                                    containerClassName={`transfer-data data-wrapper-flex ${
                                        isDesktop ? "" : "space-between"
                                    }`}
                                    label="accounts.new.account.signatures.signBy.label"
                                    data={this.signBy()}
                                />
                            </>
                        )}
                    </>
                )}
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    summary: transactionsSelectors.getSummary(state),
    fullName: sessionSelectors.getUser(state).userFullName,
});

export default compose(connect(mapStateToProps))(ExternalTransactionSummaryData);
